import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
/* eslint-disable-next-line @github-ui/github-monorepo/no-use-app-payload --
   useAppPayload is deprecated. See
   https://thehub.github.com/epd/engineering/dev-practicals/frontend/react/data-router/migration/app-payload-deprecation/ */
import {useAppPayload} from '@github-ui/react-core/use-app-payload'
import {Outlet} from '@github-ui/react-router'
import type {ReactNode} from 'react'

import {CommitsLayoutPayloadContext} from '../hooks/use-commits-app-payload'
import {type CommitsLayoutPayload, commitsLayoutRoute} from './commits-layout-route'

export function CommitsLayout() {
  const {data} = useRouteQuery(commitsLayoutRoute, 'mainQuery')

  return (
    <CommitsLayoutPayloadContext value={data}>
      <Outlet />
    </CommitsLayoutPayloadContext>
  )
}

/**
 * The view-fragment route is served from `/_view_fragments`, so it cannot nest under the
 * repo-scoped layout route and still reads these values from the app payload.
 */
export function CommitsAppPayloadProvider({children}: {children: ReactNode}) {
  const appPayload = useAppPayload<CommitsLayoutPayload>()

  return <CommitsLayoutPayloadContext value={appPayload}>{children}</CommitsLayoutPayloadContext>
}
